import {SPECS as SdkSpecs} from '@wix/wixstores-client-storefront-sdk/dist/es/src/constants';

export const SPECS = {
  ...SdkSpecs,
  SUBSCRIPTION_PLAN_USE_TPA_RADIO_BUTTON: 'specs.stores.SubscriptionPlanUseTpaRadioButton',
  USE_LIGHTBOXES: 'specs.stores.UseLightboxes',
  USE_DROPDOWN_TPA_LABEL: 'specs.stores.UseDropdownTpaLabel',
  EDITOR_OOI: 'specs.stores.EditorGalleryOOI',
  ACTIVE_DISABLED_VARIANTS: 'specs.stores.ActiveDisabledVariants',
  DISABLE_MOBILE_NATIVE_DROPDOWN: 'specs.stores.DisableMobileNativeDropdown',
  FIX_CASHIER_PROPS_PRICE_SHIFTING: 'specs.stores.ProductPageFixCashierPropsPriceShifting',
  SHOULD_USE_COMMON_DISCOUNT_PRICING_METHODS: 'specs.stores.ShouldUseCommonDiscountPricingMethods',
  LOCATION_ONCHANGE_PATH_CHANGE_FOR_EDITOR_SAUSAGE:
    'specs.stores.ProductPageLocationOnChangePathChangeForEditorSausage',
  PRODUCT_PAGE_MIGRATE_TO_RICO_DESCRIPTION: 'specs.stores.ProductPageMigrateToRicoDescription',
  NotifyEmailOnCheckout: 'specs.stores.ProductPageNotifyEmailOnCheckout',
  SHOULD_RESET_QUANTITY_UPON_SELECTION_CHANGE: 'specs.stores.GalleryProductItemResetQuantityUponSelectionChange',
  PRODUCT_PAGE_SLOTS: 'specs.stores.ProductPageSlots',
  BREADCRUMBS_AFTER_HYDRATION: 'specs.stores.ProductPageBreadcrumbsAfterHydration',
  EnableDynamicSizeDefaultImage: 'specs.stores.EnableDynamicSizeDefaultImage',
  REMOVE_MODIFIERS_SELECTION_IDS_FROM_USER_SELECTIONS: 'specs.stores.RemoveModifiersSelectionIdsFromUserSelections',
  OptimizeSelectionCalculation: 'specs.stores.OptimizeSelectionCalculation',
  SendSubcategoriesSeoDataSF: 'specs.stores.SendSubcategoriesSeoDataSF',
  ShouldCheckDiscountInVariantLevel: 'specs.stores.shouldCheckDiscountInVariantLevel',
  ShouldRemoveModifiersFromSelections: 'specs.stores.shouldRemoveModifiersFromSelections',
  MainMediaWrapperAsAnchorElement: 'specs.stores.MainMediaWrapperAsAnchorElement',
  AvifImageEncoding: 'specs.stores.AvifImageEncoding',
  ShouldProductPageUseNewSocialIcons: 'specs.stores.ShouldProductPageUseNewSocialIcons',
  ProductPageAddDelayedCapturePropToPaymentMethodsBanner:
    'specs.stores.ProductPageAddDelayedCapturePropToPaymentMethodsBanner',
  UsingStoresViewerScriptAddToCart: 'specs.stores.UsingStoresViewerScriptAddToCart',
  RtlAlignmentProductPage: 'specs.stores.RtlAlignmentProductPage',
  AddToCartButtonColorContrast: 'specs.stores.AddToCartButtonColorContrast',
  ProductPageOOIMediaNavigationToSwiper: 'specs.stores.ProductPageOOIMediaNavigationToSwiper',
  UsePrefixForRouterProductPageRendering: 'specs.stores.UsePrefixForRouterProductPageRendering',
  ProductPageOOIExpandIcon: 'specs.stores.ProductPageOOIExpandIcon',
  EnableStyleProcessorCssVarsMigration: 'specs.stores.EnableStyleProcessorCssVarsMigration',
  ProductPriceNameFixTextColor: 'specs.stores.ProductPriceNameFixTextColor',
  ShareIconsAriaFix: 'specs.stores.FixShareIconsAria',
  ProductPageA11yReflowZoomModal: 'specs.stores.ProductPageA11yReflowZoomModal',
  ProductPageOOIFixThumbnailsDisplay: 'specs.stores.ProductPageOOIFixThumbnailsDisplay',
  QuickViewFixViewMoreLink: 'specs.stores.QuickViewFixViewMoreLink',
};
